import { getField, updateField } from 'vuex-map-fields'

// eslint-disable-next-line camelcase
export const state = () => ({
  citizensCPF: undefined,
  service: undefined,
  returnCode: undefined
})

export const getters = {
  getField
}

export const actions = {
}

export const mutations = {
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
